import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/site";
const siteApi = {
  // 获取站点列表
  list() {
    return request({
      url: `${baseUrl}/list`,
      method: "GET"
    });
  },
  // 获取站点详情(最新的一条)
  getNewest() {
    return request({
      url: `${baseUrl}/getNewest`,
      method: "GET"
    });
  }
};

export default siteApi;
